import integration from './integration';
import lookup from './lookup';
import sheet from './sheet';
import variable from './variable';

const conditionals = { integration, lookup, sheet, variable };

export default conditionals;
